<template>
<div class="chapter">
<div class="inner_page">
<p class="otherfm1"><a id="page_ii"></a>Other books by John P. Schuster</p>
<p class="indentv"><em>Answering Your Call: A Guide to Living Your Deepest Purpose</em></p>
<p class="indentv"><em>The Power of Open-Book Management</em></p>
<p class="indentv"><em>The Open-Book Management Field Book</em></p>
<p class="indentv"><em>From Hum-Drum to Hot-Diggity on Leadership</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm1.vue?54d14a7c